import { connect } from "react-redux";

import Errorlog from "./Errorlog";

export default connect(state => ({
	auth: state.user
}))(Errorlog);
